export default "/images/google-play-badge.63e56559.png";